module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('div', [_c('section', {
    staticClass: "hero is-large"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "nav-toggle",
    on: {
      "click": function($event) {
        _vm.toggleHidden()
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu"
  }, [(!_vm.hideNav) ? [_c('div', {
    staticClass: "app-nav-wrapper"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": "/a/documents"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.proposals')))]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": "/a/templates"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.templates')))]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": "/a/content-blocks"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.modules')))]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": "/a/activity"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.activity')))]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": "/a/contacts"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.contacts')))])], 1), _vm._v(" "), _c('span', {
    staticClass: "nav-item new-button"
  }, [_c('a', {
    staticClass: "button is-primary is-outlined",
    on: {
      "click": function($event) {
        _vm.Events.$emit('modalOpen', 'newDocumentModal')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('navigation.new_proposal')))])])]), _vm._v(" "), _c('span', {
    staticClass: "nav-item new-button"
  }, [_c('a', {
    staticClass: "button is-primary is-outlined",
    on: {
      "click": function($event) {
        _vm.Events.$emit('modalOpen', 'newContactModal')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('navigation.new_contact')))])])])] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "nav-item account"
  }, [_c('figure', {
    staticClass: "image is-24x24 is-",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('span', {
    staticClass: "badge"
  }), _vm._v(" "), (_vm.hasUnreadNotifications || _vm.hasUnreadAnnouncements) ? _c('i', {
    staticClass: "activity-indicator"
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.user.photo_url
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-chevron-down"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "active-class": "is-active",
      "to": "/a/settings"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.account_settings')))])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-item has-activity-indicator",
    on: {
      "click": _vm.showNotifications
    }
  }, [(_vm.hasUnreadNotifications || _vm.hasUnreadAnnouncements) ? _c('i', {
    staticClass: "activity-indicator"
  }) : _vm._e(), _vm._v("Notifications\n                    ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.Events.$emit('modalOpen', 'supportFormModal', {
          supportForm: _vm.supportForm
        })
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('navigation.support')) + "\n                    ")])]), _vm._v(" "), (_vm.Spark.impersonating) ? _c('li', [_c('a', {
    attrs: {
      "href": "/spark/kiosk/users/stop-impersonating"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-user-secret"
  }), _vm._v(" " + _vm._s(_vm.$t('navigation.stop_impersonating')) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.user.is_developer) ? _c('li', [_c('a', {
    attrs: {
      "href": "/spark/kiosk"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('navigation.kiosk')) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.Events.$emit('modalOpen', 'shareModal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.spread_the_love')))])]), _vm._v(" "), _c('li', {
    staticClass: "teams"
  }, [_c('ul', [_c('span', [_vm._v(_vm._s(_vm.$t('navigation.teams')))]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('li', {
      key: team.id
    }, [_c('a', {
      class: {
        'active-team': _vm.currentTeam.id === team.id
      },
      attrs: {
        "href": '/switch-team/' + team.id
      }
    }, [_vm._v(_vm._s(team.name))])])
  })], 2)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/logout"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.log_out')))])])])])])], 2)])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/wp.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7caa6911","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/app-nav.vue
// module id = 539
// module chunks = 0